import * as React from "react";
import Reducer from "./Reducer";
import { v4 as uuidv4 } from "uuid";

export const initialState = {
  user_session: "signup_" + uuidv4(),
  render: true,
  country: "", //country ID
  username: "",
  password: "",
  confirmPassword: "",
  accountName: "",
  homeRegion: null,
  homeRegions: {},
  nextStep: false,
  firstName: "",
  lastName: "",
  countries: [{ value: {}, label: "" }],
  countryObject: null, //getCountries API call
  countryInfo: {}, //Static Config file
  companyName: "",
  departmentName: "",
  altEnglishCompanyName: "",
  jobTitle: "",
  address: {
    address1: "",
    address2: "",
    address3: "",
    address4: "",
    city: "",
    selectedState: null,
    selectedProvince: null,
    state: "",
    province: "",
    postalcode: "",
    county: "",
  },
  states: {},
  intendedUse: "PERSONAL",
  taxPayerId: "",
  phoneNumber: "",
  promotions: [],
  selectedPromo: {},
  defaultPromo: {},
  verificationCode: "",
  orgId: "",
  miniBobEnabled: true,
  sourceType: "",
  referrer: "",
  billingAddress: {},
  paymentOptions: {},
  paymentError: {},
  paymentResponse: {},
  smsNumber: "",
  operationId: "",
  consoleUri: "",
  language: "",
  paymentStatus: "",
  addressValidation: true,
  mobileValidation: true,
  showThankYou: false,
  numPaymentVerifyBtnClicked: 0,
  phoneCountryCode: "",
  addressContinueBtn: true,
  validPhoneNumber: true,
  apiError: false,
  emailToken: "",
  validateEmail: false,
  sendEmail: true,
  defaultValues: "",
  showBanner: false,
};

const Store = ({ children }) => {
  const [state, dispatch] = React.useReducer(Reducer, initialState);

  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    try {
      const defaultValues = JSON.parse(urlParams.get("defaultValues"));
      dispatch({
        type: "SET_QUERY_STATE",
        payload: defaultValues,
      });
      const values = JSON.stringify(defaultValues);
      dispatch({
        type: "SET_DEFAULT_VALUES",
        payload: values,
      });
    } catch (e) {
      console.error("Unable to parse query params", e);
    }
  }, []);

  return (
    <Context.Provider value={[state, dispatch]}>{children}</Context.Provider>
  );
};

export const Context = React.createContext(initialState);

export default Store;
